/* eslint-disable camelcase */

import { makeAutoObservable, set, toJS } from 'mobx'

class FormData {
  id = 0
  is_fixed = false
  key = ''
  value = ''

  isRequired = false
  errorMessage = ''

  constructor (data) {
    makeAutoObservable(this)
    if (data) {
      set(this, data)
    }
  }

  toObject () {
    const data = toJS({
      id: this.id,
      is_fixed: this.is_fixed,
      key: this.key,
      value: this.value
    })
    if (data.id === 0) {
      delete data.id
    }
    return data
  }
}

export default FormData
